<template>
  <div>
    <app-general-accounting-statement
      apiEndPoint="/accounting/account/statement/"
    ></app-general-accounting-statement>
  </div>
</template>

<script>
import generalAccountingStatement from "../../../accounting/generalAccountingStatement.vue";
export default {
  components: {
    appGeneralAccountingStatement: generalAccountingStatement,
  },
};
</script>

<style>
</style>
